// Notification.js
import React from 'react';
import './Notification.css'; // Подключаем файл стилей

const Notification = ({ message, type, onClose }) => {
    if (!message) return null; // Если сообщения нет, ничего не отображаем

    return (
        <div className={`notification ${type}`}>
            <span>{message}</span>
            <button onClick={onClose} className="close-btn">&times;</button>
        </div>
    );
};

export default Notification;
